import { upload } from '@vercel/blob/client';
import type { ClientFileStorage } from './client';

/** `ClientFileStorage` backed by `@vercel/blob/client`'s browser upload. */
export class VercelBlobClientStorage implements ClientFileStorage {
  async uploadFile(
    pathname: string,
    file: File,
    options: {
      contentType: string;
      clientPayload: string;
      onProgress?: (percentage: number) => void;
    }
  ): Promise<{ pathname: string }> {
    const blob = await upload(pathname, file, {
      access: 'private',
      handleUploadUrl: '/api/files/upload',
      contentType: options.contentType,
      clientPayload: options.clientPayload,
      onUploadProgress: progress => options.onProgress?.(progress.percentage)
    });
    return { pathname: blob.pathname };
  }
}
